const MATCH_FILTER_KEYS = {
  ALL: "ALL",
  FAVORITES: "FAVORITES",
  SEARCH: "SEARCH",
  CHANGES_ONLY: "CHANGES_ONLY",
  COMPANY: "COMPANY",
  SIGNALS: "SIGNALS",
  SIGNAL_TYPES: "SIGNAL_TYPES",
};

const MATCH_FILTER_NAMES = {
  [MATCH_FILTER_KEYS.ALL]: "All",
  [MATCH_FILTER_KEYS.FAVORITES]: "Favorites",
  [MATCH_FILTER_KEYS.SEARCH]: "Search",
  [MATCH_FILTER_KEYS.CHANGES_ONLY]: "Changes Only",
  [MATCH_FILTER_KEYS.SIGNALS]: "Alerts",
  [MATCH_FILTER_KEYS.SIGNAL_TYPES]: "Alert types",
};

const STAT_LEVEL_CLASSES = {
  TEAM: "team-level",
  TIME: "has-background",
  TICKER_MATCH_PART: "has-text",
  TICKER_SIGNAL_PART: "has-background",
};

const SORT_TYPES = {
  TIME: "time",
  STATS: "stats",
  TOTAL: "total",
  HANDICAP: "handicap",
  SIGNAL: "top last",
};

const SORT_ORDER = {
  ASC: "ASC",
  DESC: "DESC",
};

const SIGNAL_FILTER_KEYS = {
  CRASH: "CRASH",
  RAISE: "RAISE",
  HIGH_TRENDED: "HIGH_TRENDED",
  LOW_TRENDED: "LOW_TRENDED",
  WHALE: "WHALE",
  SHARP: "SHARP",
};

const SIGNAL_FILTER_NAMES = {
  [SIGNAL_FILTER_KEYS.SHARP]: "Sharp",
  [SIGNAL_FILTER_KEYS.WHALE]: "Whale",
  [SIGNAL_FILTER_KEYS.LOW_TRENDED]: "Low Trended",
  [SIGNAL_FILTER_KEYS.HIGH_TRENDED]: "High Trended",
  [SIGNAL_FILTER_KEYS.CRASH]: "Crash",
  [SIGNAL_FILTER_KEYS.RAISE]: "Raise",
};

const SIGNAL_FILTERS = {
  [SIGNAL_FILTER_KEYS.CRASH]: "crash",
  [SIGNAL_FILTER_KEYS.RAISE]: "raise",
  [SIGNAL_FILTER_KEYS.HIGH_TRENDED]: "highTrended",
  [SIGNAL_FILTER_KEYS.LOW_TRENDED]: "lowTrended",
  [SIGNAL_FILTER_KEYS.WHALE]: "whale",
  [SIGNAL_FILTER_KEYS.SHARP]: "sharp",
};
const ALL_COMPANY_ROW = { _id: 0, name: "All" };

const HANDICAP_ORIGINAL_KEYS = { OU: "OVER_UNDER", handicap: "HANDICAP" };
const HANDICAP_KEYS = { OVER_UNDER: "OVER_UNDER", HANDICAP: "HANDICAP" };
const HANDICAP_TYPES = {
  [HANDICAP_KEYS.OVER_UNDER]: "OU",
  [HANDICAP_KEYS.HANDICAP]: "handicap",
};
const HANDICAP_TITLES = {
  [HANDICAP_KEYS.OVER_UNDER]: "O/U", // Over / Under
  [HANDICAP_KEYS.HANDICAP]: "AH", // Asian Handicap
};
const MATCH_PART_KEYS = { HT: "HT", FT: "FT" };

export {
  MATCH_FILTER_KEYS,
  MATCH_FILTER_NAMES,
  STAT_LEVEL_CLASSES,
  SORT_ORDER,
  SORT_TYPES,
  SIGNAL_FILTER_KEYS,
  SIGNAL_FILTER_NAMES,
  SIGNAL_FILTERS,
  ALL_COMPANY_ROW,
  HANDICAP_ORIGINAL_KEYS,
  HANDICAP_TYPES,
  HANDICAP_TITLES,
  HANDICAP_KEYS,
  MATCH_PART_KEYS,
};
